import { useEffect, useState } from "react";

export const ScrollProgress = () => {
  const [p, setP] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      setP(max > 0 ? (h.scrollTop / max) * 100 : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 h-[2px] bg-black/5 z-[60] pointer-events-none"
    >
      <div
        className="h-full bg-black"
        style={{ width: `${p}%`, transition: "width 80ms linear" }}
      />
    </div>
  );
};
